import * as React from 'react'
import { Bar } from '@vx/shape'
import { Group } from '@vx/group'
import { scaleLinear } from '@vx/scale'
import { max } from 'd3-array'
import * as colors from 'styles/colors-export.css'
import { upperCase } from 'lodash'

// accessors
const x = d => d.name
const y = d => d.value

export interface IGraphHorizontalBarProps {
  width: number
  height?: number
  data: {
    name: string
    value: number
  }[]
}

export const GraphHorizontalBar = ({ width, height, data }: IGraphHorizontalBarProps) => {
  if (width < 10) return null

  const margin = {
    left: 35,
    right: 30,
  }

  const xMax = width - margin.left - margin.right

  const xScale = scaleLinear({
    rangeRound: [xMax, 0],
    domain: [0, max(data, y)],
  })

  const barHeight = 10
  const barPadding = 12

  return (
    <svg width={width} height={height}>
      <Group top={40}>
        {data.map((d, i) => {
          const xVal = x(d)
          const yVal = y(d)
          const barWidth = xMax - xScale(yVal)
          return (
            <Group key={`bar-${xVal}`} top={(barHeight + barPadding) * i}>
              <text y="9" fontSize="10">
                {upperCase(xVal)}
              </text>
              <Bar
                x={margin.left}
                width={barWidth}
                height={barHeight}
                fill={colors.tertiary}
                data={{ x: xVal, y: yVal }}
              />
              <text y="9" x={margin.left + barWidth + 5} fontSize="10">
                {yVal}
              </text>
            </Group>
          )
        })}
      </Group>
    </svg>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/GraphHorizontalBar/GraphHorizontalBar.tsx